import { SvgIcon } from "@mui/material";
import React from "react";

const CommentIcon = ({
  width = "11",
  height = "11",
  viewBox = "0 0 11 11",
  fill = "#8F8F8F",
  ...props
}) => (
  <SvgIcon
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    width={width}
    height={height}
    sx={{ display: "block", ...props.sx }}
    {...props}
  >
    <path
      d="M0 1.125V10.0085C0 10.259 0.302946 10.3845 0.480122 10.2073L2.64775 8.03976C2.75323 7.93429 2.89631 7.875 3.04549 7.875H9C9.62134 7.875 10.125 7.37134 10.125 6.75V1.125C10.125 0.503679 9.62134 0 9 0H1.125C0.503679 0 0 0.503679 0 1.125Z"
      fill={fill}
    />
  </SvgIcon>
);

export default CommentIcon;
